/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#014160" text-color="#fff" active-text-color="#fff">
      <el-button class="buttonimg">
        <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      </el-button>
      <el-submenu index="2" class="submenu">
        <!-- <template slot="title">{{user.userRealName}}</template> -->
        <template slot="title">{{ userInfo.userName }}</template>
        <el-menu-item v-show="resCodeList.indexOf('RES0010') != -1" @click="openOrg()" index="2-1">机构信息</el-menu-item>
        <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item>
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>
    <!-- 个人中心 -->
    <el-dialog :visible.sync="show" width="30%" :close-on-click-modal="false" :show-close="true" @click='closeDialog("edit")'>
      <el-descriptions class="margin-top" title="个人中心" :column="1" :size="''" border v-show="!editShow && !pwdShow">
        <template slot="extra">
          <el-button type="primary" size="small" @click="editShow = true">修改</el-button>
          <el-button type="primary" size="small" @click="pwdShow = true">重置密码</el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-picture-outline"></i>
            头像
          </template>
          <el-image
            style="width: 100px; height: 100px"
            v-if="userInfo.photo"
            :src="userInfo.photo"
            fit="cover"
            :preview-src-list="[userInfo.photo]"></el-image>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-custom"></i>
            用户名
          </template>
          {{ userInfo.account }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            名称
          </template>
          {{ userInfo.userName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            手机号
          </template>
          {{ userInfo.phone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            地区
          </template>
          {{ userInfo.areaName }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 重置密码 -->
      <el-form label-width="80px" ref="pwdForm" :model="form" v-show="pwdShow">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input size="small" maxLength="200" v-model="form.oldPassword" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input size="small" maxLength="200" v-model="form.newPassword" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="twoPassword">
          <el-input size="small" maxLength="200" v-model="form.twoPassword" placeholder="请确认登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-show="pwdShow">
        <el-button size="small" @click='pwdShow = false'>返回</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="resetpwd()">保存</el-button>
      </div>
      <!-- 修改基础数据 -->
      <el-form label-width="80px" ref="form" :model="form" :rules="rules" v-show="editShow">
        <el-form-item label="头像" prop="photo">
          <el-upload
            class="avatar-uploader"
            :action="url"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <el-image
              style="width: 100px; height: 100px"
              v-if="form.photo"
              :src="form.photo"
              fit="cover"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-input size="small" maxLength="255" v-model="form.account" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input size="small" maxLength="255" v-model="form.userName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" v-show="!form.userSeqId">
          <el-input size="small" maxLength="200" v-model="form.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input size="small" maxLength="255" v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="areaCode">
          <el-cascader
            style="width: 100%"
            :show-all-levels="false"
            v-model="form.areaCode"
            :options="areaOptions"
            emitPath="false"
            :props="{ checkStrictly: true, emitPath:false }"
            clearable></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-show="editShow">
        <el-button size="small" @click='editShow = false'>返回</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 机构信息 -->
    <el-dialog :visible.sync="orgShow" width="30%" :close-on-click-modal="false" :show-close="true" @click='closeDialog("orgEdit")'>
      <el-descriptions class="margin-top" title="机构信息" :column="1" :size="''" border v-show="!orgEditShow">
        <template slot="extra">
          <el-button type="primary" size="small" @click="orgEditShow = true">修改</el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            机构名称
          </template>
          {{ orgItem.orgName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-custom"></i>
            联系人
          </template>
          {{ orgItem.contact }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            联系电话
          </template>
          {{ orgItem.contactPhone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-promotion"></i>
            地区
          </template>
          {{ orgItem.orgArea }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            机构地址
          </template>
          {{ orgItem.orgAddress }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-picture-outline"></i>
            签章
          </template>
          <el-image
            style="width: 100px; height: 100px"
            v-if="orgItem.signatureUrl"
            :src="orgItem.signatureUrl"
            fit="cover"
            :preview-src-list="[orgItem.signatureUrl]"></el-image>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 修改基础数据 -->
      <el-form label-width="80px" ref="orgForm" :model="orgForm" :rules="orgRules" v-show="orgEditShow">
        <el-form-item label="机构名称" prop="orgName">
          <el-input size="small" maxLength="255" v-model="orgForm.orgName" placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input size="small" maxLength="255" v-model="orgForm.contact" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input size="small" maxLength="255" v-model="orgForm.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="orgArea">
          <el-input size="small" maxLength="255" v-model="orgForm.orgArea" placeholder="请输入地区"></el-input>
        </el-form-item>
        <el-form-item label="机构地址" prop="orgAddress">
          <el-input size="small" maxLength="255" v-model="orgForm.orgAddress" placeholder="请输入机构地址"></el-input>
        </el-form-item>
        <el-form-item label="签章" prop="signatureUrl">
          <el-upload
            class="avatar-uploader"
            :action="url"
            :show-file-list="false"
            :on-success="handleSignatureSuccess"
            :before-upload="beforeAvatarUpload">
            <el-image
              style="width: 100px; height: 100px"
              v-if="orgForm.signatureUrl"
              :src="orgForm.signatureUrl"
              fit="cover"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-show="orgEditShow">
        <el-button size="small" @click='orgEditShow = false'>返回</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('orgForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>


</template>
<script>
import {
  editOtherUserPassword,
  editUserSelfBasicInfo,
  editUserSelfPassword,
  logout,

  queryOrg,
  updateOrg

} from '../api/userMG'
import {queryAllArea} from "../api/student";
export default {
  name: 'navcon',
  data() {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      console.log(rule)
      console.log(value)
      console.log(callback)

      const regMobile = /^1[345789]\d{9}$/
      const isMob=/^((0\d{2,3})-)?(\d{7,8})$/;
      if (value != undefined && value != '') {
        if (regMobile.test(value) || isMob.test(value)) {
          return callback()
        }
        // 返回一个错误提示
        if (rule.field == 'phone') {
          callback(new Error('请输入合法的手机号码'))
        } else {
          callback(new Error('请输入合法的联系方式'))
        }
      } else {
        callback()
      }
    }
    return {
      resCodeList: JSON.parse(localStorage.getItem('userdata')).resCodeList,
      userInfo: JSON.parse(localStorage.getItem('userdata')),   // 用户信息
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},

      areaOptions: [],    // 地区
      loading: false,
      url: '/api/user/upload',
      show: false,
      editShow: false,
      form: {
        photo: ''
      },
      // rules表单验证
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        /*password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],*/
        phone: [
          { validator: checkMobile, trigger: 'blur' }
        ]
      },

      pwdShow: false,


      // 机构 参数
      orgItem: {},
      orgForm: {},
      orgRules: {
        orgName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        orgArea: [
          { required: true, message: '请输入地区', trigger: 'blur' }
        ],
        orgAddress: [
          { required: true, message: '请输入机构地址', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { validator: checkMobile, trigger: 'blur' }
        ],
      },
      orgShow: false,
      orgEditShow: false,

    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.queryAllArea();
    // this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {

    // 查询 地区树
    queryAllArea() {
      queryAllArea({}).then(res => {
        if (res.code == 200) {
          var list = res.data;
          list.forEach(item => {
            if (item.children.length > 0) {
              item.children.forEach(x => {
                if (x.children.length > 0) {
                  x.children.forEach(y => {
                    y.children = undefined
                  })
                } else {
                  x.children = undefined
                }
              })
            } else {
              item.children = undefined;
            }
          })

          this.areaOptions = list;
        }
      })
    },

    // 处理机构信息
    openOrg() {
      queryOrg().then(res => {
        if (res.code == 200) {
          this.orgItem = res.data;
          this.orgForm = JSON.parse(JSON.stringify(res.data));
          this.orgShow = true;
        }
      })
    },

    content() {
      this.form = JSON.parse(JSON.stringify(this.userInfo));
      this.show = true;
    },
    handleSignatureSuccess(res, file) {
      this.orgForm.signatureUrl = res.data.url;
    },
    handleAvatarSuccess(res, file) {
      /* URL.createObjectURL(file.raw) */
      this.form.photo = res.data.url;
    },
    beforeAvatarUpload(file) {
      console.log('file===', file);
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传签章图片只能是 JPG 或 PNG 格式!');
      }
      /*if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }*/
      return isJPG;
    },


    // 重置密码
    resetpwd() {
      // this.resetpsd.userId = row.userId
      if (this.form.newPassword != this.form.twoPassword) {
        this.$message({
          type: 'error',
          message: '两次密码不一致！'
        })
        return;
      }
      this.$confirm('确定要修改密码吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          editUserSelfPassword(JSON.stringify(this.form)).then(res => {
            this.show = false;
            this.loading = false
            if (res.code == 200) {
              // 数据更新
              /*this.form.password = this.form.newPassword;
              localStorage.setItem('userData', JSON.stringify(this.form));
              this.userInfo = JSON.parse(JSON.stringify(this.form))*/

              this.form = {
                photo: ''
              }
              this.pwdShow = false;
              this.$message({
                type: 'success',
                message: '修改密码成功！'
              })

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.show = false;
            this.loading = false
            this.$message.error('修改密码失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消修改密码！'
          })
        })
    },
    // 修改基础信息
    submitForm(editData) {
      if (editData == 'form') {
        this.$refs[editData].validate(valid => {
          if (valid) {
            /*if (this.form.areaCode) {
              if (typeof (this.form.areaCode) != 'string' && this.form.areaCode.length > 0) {
                this.form.areaCode = this.form.areaCode[this.form.areaCode.length - 1]
              }
            }*/

            editUserSelfBasicInfo(JSON.stringify(this.form)).then(res => {
              this.show = false
              this.loading = false
              if (res.code == 200) {
                // 数据更新
                localStorage.setItem('userData', JSON.stringify(this.form));
                this.userInfo = JSON.parse(JSON.stringify(this.form))

                this.form = {
                  photo: ''
                }
                this.editShow = false;
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
              .catch(err => {
                this.show = false
                this.loading = false
                this.$message.error('修改失败，请稍后再试！')
              })

          } else {
            return false
          }
        })
      } else if (editData == 'orgForm') {
        this.$refs[editData].validate(valid => {
          if (valid) {
            updateOrg(this.orgForm).then(res => {
              this.orgShow = false
              this.loading = false
              if (res.code == 200) {
                // 数据更新
                this.orgEditShow = false;
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.orgShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })
          } else {
            return false
          }
        })
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.pwdShow = false;
        this.editShow = false;
        this.form = {
          photo: ''
        };
        this.show = false
      } else if (dialog == 'orgEdit') {
        this.orgEditShow = false;
        this.orgForm = {};
        this.orgShow = false
      }
    },

    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout({}).then(res => {
            if (res.code == 200) {
              //如果请求成功就让他2秒跳转路由
              /*setTimeout(() => {

              }, 1000)*/
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
              this.$message({
                type: 'success',
                message: '已退出登录!'
              })
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
          .catch(err => {
            // 获取图形验证码
            // this.getcode()
            this.$message.error('退出失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}

.form-add-body {
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.jbxx {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/navcon.vue